export class PaymentCenterController {
  constructor($scope, $rootScope, $location, $anchorScroll, $modal, $window, PaymentService, UserService, toastr) {
    $scope.vm = this;
    $scope.toastr = toastr;
    this.PaymentService = PaymentService;
    this.UserService = UserService;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.anchorScroll = $anchorScroll;
    this.location = $location;
    this.modal = $modal;
    this.window = $window;

    this.init();
  }

  init() {
    this.scope.payment_step1 = true;
    this.scope.payment_step2 = false;
    this.scope.onlyPaypal = false;
    this.scope.payment = {};
    this.scope.prices = [];

    this.PaymentService.getPriceList()
    .then((response) => { let prices = response.data;
      this.scope.prices = prices.data;
    })
    .catch((response) => { let error = response.data;
      console.log(error);
    });

    this.scope.changePaymentType = () => {
      if(this.scope.payment.pay_type == 5) {
        this.scope.onlyPaypal = true;
      } else {
        this.scope.onlyPaypal = false;
      }
    };

    this.scope.paymentConditionsModal = () => {
      this.modal.open({
        templateUrl: 'paymentConditions.html',
        controller: 'PaymentCenterModalController',
      }).result.catch(angular.noop);
    };

    this.scope.resetPage = () => {
      this.scope.payment_step1 = true;
      this.scope.payment_step2 = false;
      this.scope.onlyPaypal = false;

      this.scope.payment.vip_type = null;
      this.scope.payment.pay_type = null;
      this.scope.payment.action = null;
    };

    this.scope.validatePayment = () => {
      if(this.scope.payment.pay_type == 5) {
        // for paypal payment
        this.location.path('/homerd/paypal');
        return;
      }

      if(!this.scope.payment.price) {
        this.scope.toastr.warning('SELECCIONE SU CUENTA VIP');
        return;
      }

      if(!this.scope.payment.pay_type){
        this.scope.toastr.warning('SELECCIONE MEDIO DE PAGO');
        return;
      }

      //Select another pay type
      this.scope.payment.discount = 1;
      this.scope.payment_step1 = false;
      this.scope.payment_step2 = true;
      this.anchorScroll();
    };

    this.scope.arrangePayment = () => {
      if (this.scope.payment.pay_type == 1) {
        if(this.scope.payment.discount == 1) {
          this.rootScope.payment_days = this.scope.payment.price.discount.days;
          this.rootScope.payment_price = this.scope.payment.price.discount.price;
        } else {
          this.rootScope.payment_days = this.scope.payment.price.days;
          this.rootScope.payment_price = this.scope.payment.price.price;
        }

        this.location.path('/homerd/webpayredirect');
      } else if (this.scope.payment.pay_type == 2) {
        if(this.scope.payment.discount == 1) {
          this.rootScope.payment_days = this.scope.payment.price.discount.days;
          this.rootScope.payment_price = this.scope.payment.price.discount.price;
        } else {
          this.rootScope.payment_days = this.scope.payment.price.days;
          this.rootScope.payment_price = this.scope.payment.price.price;
        }

        this.location.path('/homerd/payment-process');
      } else if (this.scope.payment.pay_type == 3) {
        if(this.scope.payment.discount == 1) {
          this.rootScope.payment_days = this.scope.payment.price.discount.days;
          this.rootScope.payment_price = this.scope.payment.price.discount.price;
        } else {
          this.rootScope.payment_days = this.scope.payment.price.days;
          this.rootScope.payment_price = this.scope.payment.price.price;
        }

        this.location.path('/homerd/payment-process');
      } else if (this.scope.payment.pay_type == 6) {
        if(this.scope.payment.discount == 1) {
          this.rootScope.payment_days = this.scope.payment.price.discount.days;
          this.rootScope.payment_price = this.scope.payment.price.discount.price;
        } else {
          this.rootScope.payment_days = this.scope.payment.price.days;
          this.rootScope.payment_price = this.scope.payment.price.price;
        }

        this.location.path('/homerd/stripe');
      } else if (this.scope.payment.pay_type == 4) {
        this.scope.payment_transfer = true;
        this.scope.payment_step1 = false;
        this.scope.payment_step2 = false;
        this.scope.payment_price = this.scope.payment.price.price;
      }

      this.anchorScroll();
    };

    this.scope.setShowPaymentCenterMessage = () => {
      let userId = this.rootScope.currentUserProfile._id;
      if(userId) {
        this.rootScope.currentUserProfile.showPaymentCenterMessage = true;
        this.UserService.updateUser({
          _id: userId,
          showPaymentCenterMessage: true
        })
      }
    };

    this.scope.print = () => {
      this.window.print();
    };
  }
}
